import React from "react";
import { Navigate, Link } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { Loader2, ShieldAlert, ArrowLeft } from "lucide-react";

export default function ProtectedRoute({ children, roles }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy-900">
        <Loader2 size={32} className="animate-spin text-white" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center text-center px-6 bg-surface">
        <div className="max-w-md">
          <div className="w-14 h-14 rounded-full bg-rose2-50 flex items-center justify-center mx-auto mb-4">
            <ShieldAlert size={28} className="text-rose2" />
          </div>
          <h1 className="t-h1 mb-2">Access denied</h1>
          <p className="t-body text-slate2 mb-6">Your role ({user.role.replace("_", " ")}) doesn't have permission to view this page. If you believe this is a mistake, contact your firm administrator.</p>
          <Link to="/app/dashboard" className="btn btn-primary"><ArrowLeft size={14} />Back to dashboard</Link>
        </div>
      </div>
    );
  }
  return children;
}
